/**
 * Return a UUID, Browser only, HTTPS only
 * https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
 * @returns {string} eg: 1f425dd5-d0c1-44b0-be69-f3329c4d9873
 */
// export function generateUuid(): string {
//   return crypto.randomUUID()
// }

export function generateUuid(): string {
  return `${Date.now()}${Math.random().toString(16).slice(2)}`
}
